/** Lumen history entries key their criterion in the formula's leading
 *  annotation: "#income-to-rent-ideal: ..." — the same keying the backend's
 *  own generation parses. */
export const ANNOTATION = /^#([a-z0-9-]+):/i;

export const humanize = (annotation: string): string => {
  const words = annotation.split("-").join(" ");
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/** "#income-to-rent-ideal: ..." → "Income to rent ideal" */
export const annotationTitle = (formula?: string | null): string | null => {
  const annotation = (formula ?? "").match(ANNOTATION)?.[1];
  return annotation ? humanize(annotation) : null;
};
